/**
 * Utility functions for image handling and alt text generation
 */

/**
 * Generates descriptive alt text for service images
 */
export const generateServiceAltText = (serviceName: string, context?: string): string => {
  const baseAlt = `${serviceName} de Junisama para eventos en Colombia`;
  return context ? `${context} - ${baseAlt}` : baseAlt;
};

/**
 * Generates descriptive alt text for client event images
 */
export const generateClientEventAltText = (
  clientName: string,
  eventName?: string,
  serviceType?: string
): string => {
  let alt = `Baños portátiles Junisama`;

  if (eventName) {
    alt += ` en ${eventName}`;
  }

  if (clientName) {
    alt += ` - Cliente: ${clientName}`;
  }

  if (serviceType) {
    alt += ` (${serviceType})`;
  }

  return alt;
};

/**
 * Generates descriptive alt text for gallery images
 */
export const generateGalleryAltText = (
  imageType: 'interior' | 'exterior' | 'detail',
  serviceName: string,
  description?: string
): string => {
  const typeMap = {
    interior: 'Interior',
    exterior: 'Vista exterior',
    detail: 'Detalle'
  };

  let alt = `${typeMap[imageType]} de ${serviceName}`;

  if (description) {
    alt += ` mostrando ${description}`;
  }

  return alt;
};

/**
 * Generates alt text for specification/feature images
 */
export const generateFeatureAltText = (
  serviceName: string,
  featureName: string
): string => {
  return `${featureName} en ${serviceName} - Junisama`;
};

/**
 * Extracts meaningful filename from image path for fallback alt text
 */
export const extractImageName = (imagePath: string): string => {
  const filename = imagePath.split('/').pop() || '';
  const nameWithoutExt = filename.replace(/\.(webp|jpg|jpeg|png|gif)$/i, '');
  // Replace hyphens and underscores with spaces and capitalize
  return nameWithoutExt
    .replace(/[-_]/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
